module.exports = __webpack_public_path__ + "images/rich_heading/sports/road_bike/icon_a40fff20f8f294462c1c32877eb66179.png";